if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_modals_watchlist_add-to-watchlist_tsx":1,"src_apis_mock_data_get-slice-limit_ts-src_components_activate-segment_margin-plus_tsx-src_com-3163e8":1,"src_modals_common_BuySellForm_tsx":1,"src_modals_common_CancelOrder_tsx":1,"default-src_apis_mock_data_get-submit-pledge-request_ts-src_apis_mock_data_get-unpledge-data_-0d2757":1,"src_components_backfill_backfill_tsx-src_components_inputs_step-number-input_tsx-src_modals_c-a8b93c":1,"default-src_components_navbar_navbarOne_module_scss":1,"src_modals_common_SellAuth_tsx":1,"src_modals_common_BulkOrderForm_tsx-src_components_activate-segment_activate-segment_module_s-5053cd":1,"default-src_pages_dashboard_dashboard_module_scss-src_components_backfill_backfill_tsx-src_co-653d15":1,"default-src_pages_search-expiry_search-expiry_module_scss-src_pages_dashboard_option-chain_oc-71d456":1,"default-src_components_buttons_buy_buy_tsx-src_components_buttons_sell_sell_tsx-src_component-b5f843":1,"default-src_pages_dashboard_bottom-menu_bottom-menu_tsx-src_pages_dashboard_header_header_tsx-1946a3":1,"default-src_components_footer_convert_convert_module_scss-src_components_footer_footerPositio-3dfdb8":1,"default-src_components_footer_footerOrder_ordersDashboard_tsx-src_components_footer_emptyMode-9f4d96":1,"src_modals_create-basket_create-basket_tsx":1,"src_modals_addToBasket_addToBasket_tsx":1,"src_pages_dashboard_fullscreen-oc-view_selectedExpiry_tsx":1,"default-src_pages_smart-strategies_smart-strategies_module_scss":1,"default-src_pages_open-interest_open-interest_module_scss":1,"src_pages_smart-strategies_smart-option-strategies_tsx-src_components_switch-button_switch_mo-252f9e":1,"src_pages_dashboard_fo-momentum_fullscreen-momentum_tsx":1,"src_pages_dashboard_stocks-menu_stocks-menu_tsx":1,"src_pages_fno-stats_fno-stats_tsx":1,"src_pages_fullscreen-fii_fullscreen-fii_tsx":1,"src_pages_ideas_ideas_tsx":1,"src_pages_smart-strategies_scalping_tsx-src_components_switch-button_switch_module_scss":1,"src_pages_strategies_strategies_tsx":1,"src_pages_stock-info_stock-info-page_tsx-node_modules_react-multi-carousel_lib_styles_css-nod-83bd8f":1,"src_pages_smart-strategies_strategie-dashboard_tsx-src_components_switch-button_switch_module-1c5648":1,"default-src_components_footer_footerBasket_basketDashboardNew_tsx":1,"src_components_footer_footerNews_footerNews_tsx":1,"default-src_components_footer_footerVtt_singleVttOrderDescription_tsx-src_components_footer_f-2c6d19":1,"src_components_footer_watchlist_footer-watchlist-tab_tsx":1,"src_pages_basketPage_basketPage_tsx":1,"src_pages_ordersPage_ordersPage_tsx":1,"src_pages_positionsPage_positionsPage_tsx":1,"src_pages_vttPage_vttPage_tsx":1,"src_pages_straddle-chart_straddle-chart_tsx":1,"src_components_footer_footerHoldings_holdingsDashboard_tsx":1,"src_pages_dashboard_screener_screener_tsx":1,"src_components_switch-button_switch_module_scss-src_pages_smart-strategies_confirmation-modal-6574b6":1,"defaultVendors-node_modules_ag-grid-community_styles_ag-grid_css":1,"defaultVendors-node_modules_ag-grid-community_styles_ag-theme-alpine_css":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded